import isSelectable from './selectable';

const getHoverCursor = shape => ((isSelectable(shape) && !(shape.get('isBackground'))) ? 'move' : 'auto');

export default getHoverCursor;
